module.exports = __webpack_public_path__ + "static/ogimage-20da3fa54ac899fdaf4f15306597759e.jpg";